import Styled from 'styled-components'

export const DivNavigate = Styled.nav`

`

export const Container = Styled.div`
border-bottom: 1px solid #C6C6C5; 
background-color: var(--background-app);  
width: 100%;
text-align: center;
display: inline-block;
`

export const Informations = Styled.div`
display:flex;
justify-content: center;
gap: 14%;
margin: 15px 0 5px;

    p {
        display: flex;
        flex-direction: column;
        text-align: center;
        font-size: 14px;
       
    
        @media (max-width: 800px) {
        margin-right: -7px;
        margin-left: -7px;
        color: var(--text-color);
    }

    span {
        color: var(--text-color);
        opacity: 0.5;
        font-size: 12px;
   }
}

@media(max-width: 800px) {
    gap: 45px;
}
`

export const SummaryContainer = Styled.div`
  padding: 0px 32px 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
  gap: 32px;
  background: var(--background-app);
  margin-top: 32px;
`

export const SummaryContent = Styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 4px;
  flex: 1;
  min-width: 0;
`

export const SummaryTitle = Styled.p`
  font-family: var(--font-family-base);
  font-weight: 600;
  font-size: 16px;
  color: var(--title-color);
  margin: 0;
  line-height: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`

export const SummaryDetails = Styled.p`
  font-family: var(--font-family-base);
  font-weight: 400;
  font-size: 14px;
  color: var(--text-color);
  margin: 0;
  line-height: normal;
`

export const EditButton = Styled.p`
  font-family: var(--font-family-base);
  font-weight: 600;
  font-size: 14px;
  color: var(--primary-color);
  margin: 0;
  text-decoration: underline;
  cursor: pointer;
`

export const ContainerDate = Styled.div`
display: flex;
justify-content: space-between;
margin-top: -10px;

.test{
    width: 60px;
}
`
